import { ShiftTypes } from '@app/entities/enums/momo/shift-types.enum';

export class MomoSchedule {
  months!: MomoScheduleMonth[];
}

export class MomoScheduleDay {
  date!: string;
  dayLabel!: string | null;
  dayName!: string;
  centerNumber!: string | null;
  dayType!: MomoScheduleDayType | null;
  taskList!: MomoScheduleDayTaskList[];
  schedule!: MomoScheduleDayShift | null;
  selected?: boolean;
}

export class MomoScheduleDayType {
  ids!: number[];
  name!: string;
  primaryColour!: string;
  secondaryColour!: string;
  primaryShape!: string;
  secondaryShape!: string;
  isWorkingDay!: boolean;
}

export class MomoScheduleWeek {
  days!: MomoScheduleDay[];
}

export class MomoScheduleMonth {
  observations!: MomoScheduleObservations;
  monthLabel!: string;
  monthNumber!: number;
  yearLabel!: string;
  weeks!: MomoScheduleWeek[];
}

export class MomoScheduleObservations {
  lastMonthHours!: string;
  theoricalHours!: string;
  workedHours!: string;
  currentMonthHours!: string;
  daysOffTaken!: number;
  notes!: string;
  lastUpdatedDate!: string;
}

export class MomoScheduleDayShift {
  start!: string;
  end!: string;
  shiftType!: ShiftTypes;
  workingHours!: string;
  shiftColor!: string;
  shiftBgColor!: string;
}

export class MomoScheduleDayTaskList {
  label!: string;
}
